import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import Slide from '@mui/material/Slide';
import { List, ListItem, ListItemText, ListItemSecondaryAction, Collapse } from '@mui/material';
import { MenuItem } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MobileMenuIcon from './MobileMenuIcon';
import { useNavigate } from 'react-router-dom';
import ExternalLinks from '../../../shared/externalLinks';
import Styles from './css/MobileHeaderStyles';

const MobileHeader = () => {
    const navigate = useNavigate();
    const containerRef = React.useRef(null);
    const [supportMenuOpen, setSupportMenuOpen] = React.useState<boolean>(false);
    const [getStartedMenuOpen, setGetStartedMenuOpen] = React.useState<boolean>(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (anchorEl != null) {
            setAnchorEl(null);
        }
        else {
            setAnchorEl(containerRef.current);
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (<Box sx={Styles.Root}>
        <AppBar sx={Styles.AppBar}>
            <Toolbar variant="dense" sx={Styles.MobileToolbar}>
                <Box sx={Styles.ToolbarContent}>
                    <img onClick={() => { navigate('/') }} style={Styles.Logo as React.CSSProperties} alt="Aipex Logo (gray)" src={ExternalLinks.AIPEX_LOGO}></img>
                    <Box sx={Styles.MobileMenuIconContainer}>
                        <IconButton onClick={handleClick}>
                            <MobileMenuIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Toolbar>
        </AppBar>
        <Box ref={containerRef} sx={Styles.MobileMenuContainer}></Box>
        <Popover sx={Styles.MobileMenu} open={open} anchorEl={anchorEl} onClose={handleClose} slotProps={{ paper: { style: Styles.PopoverPaper } }} TransitionComponent={Slide} >
            <List sx={Styles.DropdownList}>
                <MenuItem sx={Styles.MobileMenuItem} onClick={() => { window.location.href = ExternalLinks.MARKETING.HOSPITALITY.HOME; }}>
                    <ListItemText>Hospitality</ListItemText>
                </MenuItem>

                <MenuItem sx={Styles.MobileMenuItem} onClick={() => { window.location.href = ExternalLinks.MARKETING.HOSPITALITY.PRICING; }}>
                    <ListItemText>Pricing</ListItemText>
                </MenuItem>

                <ListItem sx={Styles.MobileMenuItem} onClick={() => { setSupportMenuOpen(!supportMenuOpen) }}>
                    <ListItemText sx={Styles.SubmenuItem}>Support</ListItemText>
                    <ListItemSecondaryAction>
                        <ExpandMore />
                    </ListItemSecondaryAction>
                </ListItem>
                <Collapse in={supportMenuOpen} timeout="auto" unmountOnExit>
                    <MenuItem sx={Styles.SubmenuChild} onClick={() => { window.location.href = ExternalLinks.MARKETING.SUPPORT.GETTING_STARTED.HOME; }}>
                        <ListItemText>Get Started</ListItemText>
                    </MenuItem>
                    <MenuItem sx={Styles.SubmenuChild}  onClick={() => { window.location.href = ExternalLinks.MARKETING.SUPPORT.LEARN.HOME; }}>
                        <ListItemText>Learn</ListItemText>
                    </MenuItem>
                    <MenuItem sx={Styles.SubmenuChild}  onClick={() => { window.location.href = ExternalLinks.MARKETING.SUPPORT.TROUBLESHOOT.HOME; }}>
                        <ListItemText>Troubleshoot</ListItemText>
                    </MenuItem>
                    <MenuItem sx={Styles.SubmenuChild}  onClick={() => { window.location.href = ExternalLinks.MARKETING.SUPPORT.TROUBLESHOOT.FAQ; }}>
                        <ListItemText>FAQ</ListItemText>
                    </MenuItem>
                </Collapse>
                
                <MenuItem sx={Styles.MobileMenuItem} onClick={() => { window.location.href = ExternalLinks.MARKETING.SENIOR_LIVING.HOME; }}>
                    <ListItemText>Senior Living</ListItemText>
                </MenuItem>

                <MenuItem sx={Styles.MobileMenuItem} onClick={() => { window.location.href = ExternalLinks.VCS_PORTAL.HOME; }}>
                    <ListItemText>Log In</ListItemText>
                </MenuItem>

                <ListItem sx={Styles.MobileMenuItem} onClick={() => { setGetStartedMenuOpen(!getStartedMenuOpen) }}>
                    <ListItemText sx={Styles.SubmenuItem}>Get Started</ListItemText>
                    <ListItemSecondaryAction>
                        <ExpandMore />
                    </ListItemSecondaryAction>
                </ListItem>
                <Collapse in={getStartedMenuOpen} timeout="auto" unmountOnExit>
                    <MenuItem sx={Styles.SubmenuChild} onClick={() => { window.location.href = ExternalLinks.MARKETING.HOSPITALITY.GET_STARTED; }}>
                        <ListItemText>Hospitality</ListItemText>
                    </MenuItem>
                    <MenuItem sx={Styles.SubmenuChild} onClick={() => { window.location.href = ExternalLinks.MARKETING.SENIOR_LIVING.CONTACT; }}>
                        <ListItemText>Senior Living</ListItemText>
                    </MenuItem>
                </Collapse>
            </List>
        </Popover>
    </Box>
    );
}

export default MobileHeader;